import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider as ReduxProvider } from 'react-redux';
import store from './redux/store';
import { Providers } from './providers/Providers';
import { PoolContextProvider } from './context';
import { BrowserRouter } from 'react-router-dom';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
		<Providers>
			<ReduxProvider store={store}>
				<BrowserRouter>
			<PoolContextProvider>

				<App />
			</PoolContextProvider>
				</BrowserRouter>
			</ReduxProvider>
		</Providers>
  </React.StrictMode>
);

